import { ModelTypeOption } from './constants/recs-model-type.constants';
import { prefix as FrequentlyBoughtTogetherPrefix } from './constants/frequently-bought-together.constants';
import { prefix as OthersYouMayLikePrefix } from './constants/others-you-may-like.constants';
import { prefix as RecommendedForYouPrefix } from './constants/recommended-for-you.constants';
import { prefix as OnSalePrefix } from './constants/on-sale.constants';
const prefixDelimiter = ':';
const prefixByModelType = {
    [ModelTypeOption.BuyItAgain]: '',
    [ModelTypeOption.OnSaleItems]: OnSalePrefix,
    [ModelTypeOption.FrequentlyBoughtTogether]: FrequentlyBoughtTogetherPrefix,
    [ModelTypeOption.OthersYouMayLike]: OthersYouMayLikePrefix,
    [ModelTypeOption.RecommendedForYou]: RecommendedForYouPrefix,
    [ModelTypeOption.SimilarItems]: '',
};
// Shallow remove prefixes from object keys and omits unrelated props
const trimObjectPrefix = (obj, prefix) => {
    if (!obj)
        return obj;
    return Object.keys(obj).reduce((formattedObj, currKey) => {
        const parts = currKey.split(prefixDelimiter);
        const [foundPrefix, key] = parts.length > 1 ? [parts[0] + prefixDelimiter, parts[1]] : ['', parts[0]];
        if (foundPrefix && foundPrefix !== prefix) {
            // skip props with unrelated prefixes
            return formattedObj;
        }
        formattedObj[key] = obj[currKey];
        return formattedObj;
    }, {});
};
export const formatRecsModel = (model) => trimObjectPrefix(model, prefixByModelType[model.type]);
